import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-toastify';
import AppNavbar from './AppNavbar';

const API_BASE = 'https://hospital.rozeetechnist.com/hospital-api';

const ExpenseCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    expense_date: new Date(),
    title: '',
    amount: '',
    paid_to: '',
    paid_by: '',
    notes: '',
  });

  useEffect(() => {
    if (!localStorage.getItem('login')) navigate('/login');
  }, [navigate]);

  const getLoggedUserId = () => {
    try {
      const user = JSON.parse(localStorage.getItem('login') || '{}');
      return user.id || null;
    } catch (e) {
      return null;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (date) => {
    setForm((prev) => ({ ...prev, expense_date: date }));
  };

  const formatDate = (d) => {
    if (!d) return '';
    const dt = d instanceof Date ? d : new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, '0');
    const day = String(dt.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title.trim()) {
      toast.error('Title is required.');
      return;
    }
    const payload = {
      expense_date: formatDate(form.expense_date),
      title: form.title.trim(),
      amount: parseFloat(form.amount) || 0,
      paid_to: form.paid_to.trim() || null,
      paid_by: form.paid_by.trim() || null,
      notes: form.notes.trim() || null,
      created_by: getLoggedUserId(),
    };

    setLoading(true);
    fetch(`${API_BASE}/createExpense.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((resp) => {
        setLoading(false);
        if (resp.status) {
          toast.success(resp.message);
          navigate('/expense-list');
        } else {
          toast.error(resp.message || 'Failed to create expense.');
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        toast.error('An error occurred.');
      });
  };

  return (
    <div>
      <AppNavbar />
      <div className="container">
        <div className="row top-page-bar">
          <div className="col-9">
            <div className="main-title">
              <h1>Add Expense</h1>
            </div>
          </div>
          <div className="col-3">
            <div className="search-area">
              <div className="buttons">
                <Link className="btn btn-secondary" to="/expense-list">Back</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <form onSubmit={handleSubmit} className="row g-3">
          <div className="col-md-3">
            <label className="form-label">Date</label>
            <DatePicker
              selected={form.expense_date}
              onChange={handleDateChange}
              dateFormat="yyyy-MM-dd"
              className="form-control"
            />
          </div>
          <div className="col-md-9">
            <label className="form-label">Title</label>
            <input
              className="form-control"
              name="title"
              value={form.title}
              onChange={handleChange}
              placeholder="Title"
              required
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Amount</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              name="amount"
              value={form.amount}
              onChange={handleChange}
              placeholder="Amount"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Paid To</label>
            <input
              className="form-control"
              name="paid_to"
              value={form.paid_to}
              onChange={handleChange}
              placeholder="Paid To"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Paid By</label>
            <input
              className="form-control"
              name="paid_by"
              value={form.paid_by}
              onChange={handleChange}
              placeholder="Paid By"
            />
          </div>
          <div className="col-12">
            <label className="form-label">Notes</label>
            <textarea
              className="form-control"
              name="notes"
              rows={3}
              value={form.notes}
              onChange={handleChange}
              placeholder="Notes"
            />
          </div>
          <div className="col-12">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExpenseCreate;
